<template>
  <div class="register-page-container">
    <div class="register-page-wrapper">
      <div class="register-container">
        <b-card>
          <div class="logo-wrapper">
            <img :src="logo" alt="" />
          </div>
          <h5 style="color: #ffffff" class="mb-3">Continue with Email</h5>
          <!--      <div class="title-wrapper">
                  <h4>register</h4>
                </div>-->
          <b-form>
            <div class="input-wrapper">
              <label for="name">Name</label>
              <input
                v-model="formData.name"
                id="name"
                placeholder="Enter your name"
                autocomplete="off"
              />
              <div class="form-group__message " v-if="!$v.formData.name.required && $v.formData.name.$error">
                Field is required
              </div>
              <!--              <div class="form-group__message" v-if="errorMapper.email">
                              {{errorMapper.email}}
                            </div>-->
            </div>
            <div class="input-wrapper">
              <label for="email">Email</label>
              <input
                v-model="formData.email"
                id="email"
                placeholder="Enter your email"
                autocomplete="off"
              />
              <div class="form-group__message " v-if="!$v.formData.email.required && $v.formData.email.$error">
                Field is required
              </div>
              <div class="form-group__message " v-if="$v.formData.email.required && $v.formData.email.$invalid">
                Enter valid email
              </div>
            </div>
            <div class="input-wrapper">
              <label for="date">Date</label>
              <input
                type="date"
                id="date"
                v-model="formData.dob"
                placeholder="Date"
              />
              <div class="form-group__message " v-if="!$v.formData.dob.required && $v.formData.dob.$error">
                Field is required
              </div>
            </div>
            <div class="input-wrapper">
              <label for="gender">Select Gender</label>
              <select name="gender" v-model="formData.gender" id="gender">
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <div class="form-group__message " v-if="!$v.formData.gender.required && $v.formData.gender.$error">
                Field is required
              </div>
            </div>
            <div class="input-wrapper">
              <label for="password">Phone Number</label>
              <input
                type="text"
                id="phoneNumber"
                v-model="formData.phone"
                placeholder="+112560004050"
              />
              <div class="form-group__message " v-if="!$v.formData.phone.required && $v.formData.phone.$error">
                Field is required
              </div>
            </div>
            <div class="input-wrapper">
              <label for="password">Password</label>
              <input
                type="password"
                id="password"
                v-model="formData.password"
                placeholder="Enter your password"
              />
              <div class="form-group__message " v-if="!$v.formData.password.required && $v.formData.password.$error">
                Field is required
              </div>
            </div>
            <div class="input-wrapper">
              <label for="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                v-model="formData.confirmPassword"
                placeholder="Re-Enter your password"
              />
              <div class="form-group__message"
                   v-if="!$v.formData.confirmPassword.required && $v.formData.confirmPassword.$error"> Field is required </div>
              <div class="form-group__message"
                   v-if="$v.formData.confirmPassword.required && !$v.formData.confirmPassword.sameAsPassword && $v.formData.confirmPassword.$error">
                Passwords must be identical.
              </div>
            </div>
            <div class="text-center">
              <div class="mb-2">
                <router-link style="color: #fff; font-size: 13px" to="/login">
                  Login
                </router-link>
              </div>
              <b-btn class="btn-yellow" @click.prevent="submit">Register</b-btn>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import appLogo from "@/assets/img/logo.svg";
import {email, required, sameAs} from "vuelidate/lib/validators";

export default {
  name: "register",
  data() {
    return {
      logo: appLogo,
      formData: {
        email: "",
        name: "",
        password: "",
        confirmPassword: "",
        dob: "",
        gender: "",
        phone: "",
      },
    };
  },
  validations: {
    formData: {
      name: {
        required,
      },
      email: {
        required,
        email
      },
      password: {
        required,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password')
      },
      dob: {
        required,
      },
      gender: {
        required,
      },
      phone: {
        required,
      },
    }
  },
  methods: {
    submit() {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.$store
            .dispatch("auth/register", this.formData)
            .then(() => {
              this.$notify({
                type: "success",
                title: "Register",
                text: "User registered successfully",
              });
              this.$router.push("/login");
            })
            .catch((e) => {
              this.$notify({
                type: "error",
                title: "Failed",
                text: "Failed to register",
              });
              console.log("err => ", e);
            });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-page-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #024089;
  height: 100vh;
  width: 100vw;

  .register-page-wrapper {
    height: 100%;
    width: 100%;
  }
}
.register-container {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;

  .logo-wrapper {
    margin-bottom: 14px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 50px;
      width: 50px;
    }
  }
  .card {
    background-color: transparent;
    border-color: transparent;
  }

  .input-wrapper {
    position: relative;
    margin-bottom: 15px;
    label {
      position: absolute;
      font-size: 13px;
      font-weight: lighter;
      top: -5px;
      left: 10px;
      color: #fff;
    }
    input {
      width: 100%;
      padding: 8px 10px;
      font-weight: lighter;
      color: #ffffff;
      background-color: transparent !important;
      border-color: transparent !important;
      border-bottom: 1px solid #ffffff !important;
      outline: none;

      &::placeholder {
        font-weight: lighter;
        font-size: 11px;
        color: lightblue;
      }
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        box-shadow: transparent !important;
        -webkit-box-shadow: transparent !important;
      }
    }
    select {
      width: 100%;
      padding: 8px 10px;
      font-weight: lighter;
      color: #ffffff;
      background-color: transparent !important;
      border-color: transparent !important;
      border-bottom: 1px solid #ffffff !important;
      outline: none;

      &::placeholder {
        font-weight: lighter;
        font-size: 11px;
        color: lightblue;
      }
      option {
        background-color: #f8f8f8;
        color: #024089;
      }
    }
  }

  .btn-yellow {
    background: #f1bc04;
    border-color: #f1bc04;
    border-radius: 45px;
    color: #000000;
    width: 145px;
    height: 40px;
    line-height: 21px;
    letter-spacing: 0.05em;
  }
}
input[type="date"]::-webkit-calendar-picker-indicator {
  color: #ffffff;
  opacity: 1;
  display: block;
  background: url(https://mywildalberta.ca/images/GFX-MWA-Parks-Reservations.png)
    no-repeat;
  width: 20px;
  height: 20px;
  border-width: thin;
}
</style>
